var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from '../BaseWidget';
import Button from './Button';
import ButtonStyles from './Button.less';
import ClassNames from './Button.less';
import { defaultMemoize } from 'reselect';
import { resolveTestId } from '@cvent/nucleus-test-automation';
var Classes = __assign(__assign({}, ClassNames), { button: __assign(__assign({}, ButtonStyles), { disabled: ClassNames.disabled }) });
/**
* Data wrapper for the default button widget.
*/
var ButtonWidget = /** @class */ (function (_super) {
    __extends(ButtonWidget, _super);
    function ButtonWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = _this.onClick.bind(_this);
        _this.onLinkClick = _this.onLinkClick.bind(_this);
        _this.getLinkConfig = defaultMemoize(_this.getLinkConfig);
        return _this;
    }
    ButtonWidget.prototype.onClick = function () {
        var isGuest = this.props.isGuest;
        if (!isGuest) {
            return;
        }
        this.props.clickHandler(this.props);
    };
    ButtonWidget.prototype.onLinkClick = function () {
        var _a = this.props, isGuest = _a.isGuest, linkClickHandler = _a.linkClickHandler;
        if (isGuest && linkClickHandler) {
            linkClickHandler(this.props);
        }
    };
    ButtonWidget.prototype.getLinkConfig = function (config, onClick, translate) {
        return config && __assign(__assign({}, config), { onClick: onClick, text: translate(config.text) });
    };
    ButtonWidget.prototype.getStyleObject = function () {
        var buttonStyles = this.getElementInlineStyle('button'); // Removes text alignment from the button text [PROD-101039 / NUKE-7037]
        delete buttonStyles.textAlign;
        if (this.props.disabled) {
            delete buttonStyles.backgroundColor;
            delete buttonStyles.borderColor;
            delete buttonStyles.borderBottomColor;
            delete buttonStyles.color;
        }
        return __assign(__assign({}, _super.prototype.getStyleObject.call(this)), { button: {
                button: buttonStyles
            }, buttonWrapper: {
                textAlign: this.getElementText('button').textAlign
            }, linkWrapper: {
                textAlign: this.getElementText('link').textAlign,
                overflow: this.getElementText('link').overflow
            }, link: this.getElementInlineStyle('link') });
    };
    ButtonWidget.prototype.render = function () {
        var _a = this.props, config = _a.config, translate = _a.translate, classes = _a.classes, kind = _a.kind, disabled = _a.disabled; // Originally, buttons were implemented with rich text editors, but since then
        // they have been updated to be normal textboxes. So we have to allow the text
        // property to come in as rich text or normal plain text. https://jira/browse/FLEX-6581
        var isRichText = false;
        var text = config.text;
        if (config.text.hasOwnProperty('htmlContent')) {
            isRichText = true;
            text = config.text.htmlContent;
        }
        return React.createElement(Button, __assign({}, resolveTestId(this.props), { classes: classes, style: this.getStyleObject(), kind: kind, text: translate(text), onClick: this.onClick, disabled: disabled, link: this.getLinkConfig(config.link, this.onLinkClick, translate), isRichText: isRichText }));
    };
    ButtonWidget.displayName = 'ButtonWidget';
    ButtonWidget.propTypes = {
        isGuest: PropTypes.bool,
        type: PropTypes.string,
        config: PropTypes.shape({
            text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
            link: PropTypes.shape({
                enabled: PropTypes.bool.isRequired,
                text: PropTypes.string.isRequired
            })
        }),
        classes: PropTypes.object,
        style: PropTypes.object,
        translate: PropTypes.func,
        kind: PropTypes.string,
        clickHandler: PropTypes.func,
        linkClickHandler: PropTypes.func,
        disabled: PropTypes.bool
    };
    ButtonWidget.defaultProps = {
        classes: Classes
    };
    return ButtonWidget;
}(BaseWidget));
export default ButtonWidget;
